import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cellPhoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;

    // Remove all non-numeric characters except \u2217
    let formattedNumber = value.replace(/[^\d\u2217]/g, '');

    if (/^\u2217+$/.test(value)) {
      // If it contains \u2217 characters
      formattedNumber = value.replace(
        /(\u2217{3})(\u2217{3})(\u2217{4})/,
        '$1-$2-$3',
      );
    } else {
      // Format the phone number (e.g., (123) 456-7890)
      formattedNumber = value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }

    return formattedNumber;
  }
}
